<template>
  <div id="goodsDetail" style="margin: 0 auto; background: white">
    <div class="detail-header">
      <el-button size="small" icon="el-icon-back" @click="goBack">返回列表</el-button>
      <span class="detail-title" v-if="goodsInfo">{{ goodsInfo.asin }} - {{ goodsInfo.name }}</span>
    </div>

    <div v-if="goodsInfo" class="detail-content">
      <!-- 商品基本信息 -->
      <div class="info-card">
        <el-row :gutter="20">
          <el-col :span="3">
            <el-image :src="goodsInfo.image" style="width: 80px; height: 80px" fit="fill"></el-image>
          </el-col>
          <el-col :span="21">
            <div class="info-name">{{ goodsInfo.name }}</div>
            <div class="info-row">
              <span>ASIN: <b>{{ goodsInfo.asin }}</b></span>
              <span>父ASIN: <b>{{ goodsInfo.parentAsin }}</b></span>
              <span>品牌: <b>{{ goodsInfo.brand }}</b></span>
            </div>
            <div class="info-row">
              <span>当前排名: <b :class="getRankClass(goodsInfo.rank)">{{ goodsInfo.rank != null ? goodsInfo.rank : '-' }}</b></span>
              <span>排名增速: <b :class="getDifClass(goodsInfo.rankAverageDif)">{{ goodsInfo.rankAverageDif }}</b></span>
              <span>评论增速: <b :class="getDifClass(goodsInfo.commentAverageDif)">{{ goodsInfo.commentAverageDif }}</b></span>
              <span>评论数: <b>{{ goodsInfo.commentCount != null ? goodsInfo.commentCount : '-' }}</b></span>
              <span>价格: <b>{{ goodsInfo.unitPrice != null ? goodsInfo.unitPrice : '-' }}</b></span>
              <span>评分: <b>{{ goodsInfo.score != null ? goodsInfo.score : '-' }}</b></span>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 历史趋势图表 -->
      <div class="section-box">
        <div class="section-title">历史趋势</div>
        <div id="historyChart" style="width: 100%; height: 350px"></div>
      </div>

      <!-- 历史数据明细 -->
      <div class="section-box">
        <div class="section-title">历史数据明细</div>
        <el-table :data="goodsInfo.goodsHistoryList" border size="mini" max-height="400">
          <el-table-column label="日期" width="100" align="center">
            <template v-slot="{ row }">{{ formatVersion(row.version) }}</template>
          </el-table-column>
          <el-table-column label="排名" width="100" align="center">
            <template v-slot="{ row }">
              <span :class="getRankClass(row.rank)">{{ row.rank != null ? row.rank : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="销量" width="100" align="center">
            <template v-slot="{ row }">{{ row.sales != null ? row.sales : '-' }}</template>
          </el-table-column>
          <el-table-column label="评论数" width="100" align="center">
            <template v-slot="{ row }">{{ row.comments != null ? row.comments : '-' }}</template>
          </el-table-column>
          <el-table-column label="价格" width="100" align="center">
            <template v-slot="{ row }">{{ row.price != null ? row.price : '-' }}</template>
          </el-table-column>
          <el-table-column label="评分" width="100" align="center">
            <template v-slot="{ row }">{{ row.score != null ? row.score : '-' }}</template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 竞品表现 -->
      <div class="section-box">
        <div class="section-title">竞品表现</div>
        <div v-if="goodsInfo.competitionHistoryList && goodsInfo.competitionHistoryList.length > 0">
          <el-table :data="goodsInfo.competitionHistoryList" border size="mini" max-height="400">
            <el-table-column prop="asin" label="ASIN" width="130" align="center"></el-table-column>
            <el-table-column label="日期" width="100" align="center">
              <template v-slot="{ row }">{{ formatVersion(row.version) }}</template>
            </el-table-column>
            <el-table-column label="排名" width="100" align="center">
              <template v-slot="{ row }">
                <span :class="getRankClass(row.rank)">{{ row.rank != null ? row.rank : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="销量" width="100" align="center">
              <template v-slot="{ row }">{{ row.sales != null ? row.sales : '-' }}</template>
            </el-table-column>
            <el-table-column label="评论数" width="100" align="center">
              <template v-slot="{ row }">{{ row.comments != null ? row.comments : '-' }}</template>
            </el-table-column>
            <el-table-column label="价格" width="100" align="center">
              <template v-slot="{ row }">{{ row.price != null ? row.price : '-' }}</template>
            </el-table-column>
            <el-table-column label="评分" width="100" align="center">
              <template v-slot="{ row }">{{ row.score != null ? row.score : '-' }}</template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="empty-text">暂无竞品数据</div>
      </div>
    </div>

    <div v-else-if="loading" style="text-align: center; padding: 60px; color: #909399">加载中...</div>
    <div v-else style="text-align: center; padding: 60px; color: #909399">未找到商品数据</div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {goodsStatisticsModules} from "@r";

export default {
  data() {
    return {
      loading: false,
      goodsInfo: null,
      chartInstance: null,
    };
  },
  mounted() {
    this.fetchData();
    this.$eventBus.$on("resize", this.onResize);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.onResize);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
  methods: {
    fetchData() {
      var asin = this.$route.query.asin;
      var shopId = this.$route.query.shopId;
      if (!asin || !shopId) return;

      this.loading = true;
      goodsStatisticsModules
        .page({shopId: shopId, asin: asin, currentPage: 1, pageSize: 1})
        .then(res => {
          this.loading = false;
          if (res.code === "00000" && res.data.records && res.data.records.length > 0) {
            this.goodsInfo = res.data.records[0];
            this.$nextTick(function () {
              this.initChart();
            });
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message({type: "error", message: "加载失败"});
        });
    },
    initChart() {
      var chartDom = document.getElementById("historyChart");
      if (!chartDom || !this.goodsInfo) return;

      if (this.chartInstance) {
        this.chartInstance.dispose();
      }

      var history = this.goodsInfo.goodsHistoryList || [];
      var self = this;
      var dates = history.map(function (h) {
        return self.formatVersion(h.version);
      });

      var seriesConfig = [
        {key: "rank", name: "排名", color: "#5470c6"},
        {key: "sales", name: "销量", color: "#91cc75"},
        {key: "comments", name: "评论数", color: "#fac858"},
        {key: "price", name: "价格", color: "#ee6666"},
        {key: "score", name: "评分", color: "#73c0de"},
      ];

      var series = [];
      var legendData = [];

      seriesConfig.forEach(function (config) {
        var data = history.map(function (h) {
          return h[config.key];
        });
        if (data.some(function (v) { return v != null; })) {
          series.push({
            name: config.name,
            type: "line",
            data: data,
            connectNulls: true,
            symbolSize: 6,
            itemStyle: {color: config.color},
            yAxisIndex: config.key === "rank" ? 0 : 1,
          });
          legendData.push(config.name);
        }
      });

      if (series.length === 0) {
        chartDom.innerHTML =
          '<div style="text-align:center;color:#909399;line-height:350px;font-size:14px">暂无可绘制的历史数据</div>';
        return;
      }

      var chart = echarts.init(chartDom);
      this.chartInstance = chart;

      var hasRank = legendData.indexOf("排名") >= 0;
      var hasOther = series.some(function (s) { return s.yAxisIndex === 1; });

      var yAxis = [];
      if (hasRank) {
        yAxis.push({
          type: "value",
          name: "排名",
          inverse: true,
          axisLabel: {formatter: "{value}"},
        });
      }
      if (hasOther) {
        yAxis.push({
          type: "value",
          name: "数值",
          axisLabel: {formatter: "{value}"},
        });
      }
      if (!hasRank && hasOther) {
        series.forEach(function (s) { s.yAxisIndex = 0; });
      }

      var option = {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            var result = params[0].axisValue + "<br/>";
            params.forEach(function (p) {
              if (p.value != null) {
                result += p.marker + " " + p.seriesName + ": " + p.value + "<br/>";
              }
            });
            return result;
          },
        },
        legend: {
          data: legendData,
          bottom: 0,
        },
        grid: {
          left: 60,
          right: hasOther && hasRank ? 60 : 30,
          top: 30,
          bottom: 40,
        },
        xAxis: {
          type: "category",
          data: dates,
          boundaryGap: false,
        },
        yAxis: yAxis,
        series: series,
      };

      chart.setOption(option);
    },
    formatVersion(version) {
      if (!version) return "";
      var str = String(version);
      return str.substring(0, 4) + "-" + str.substring(4, 6) + "-" + str.substring(6, 8);
    },
    getRankClass(rank) {
      if (rank == null) return "";
      if (rank <= 10) return "rank-top";
      if (rank <= 100) return "rank-good";
      if (rank <= 500) return "rank-mid";
      return "";
    },
    getDifClass(val) {
      if (val > 0) return "dif-up";
      if (val < 0) return "dif-down";
      return "";
    },
    goBack() {
      location.href = "/client/commodityMgmtV2";
    },
    onResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
  },
};
</script>

<style lang="scss">
#goodsDetail {
  padding: 15px;

  .detail-header {
    margin-bottom: 15px;
    display: flex;
    align-items: center;

    .detail-title {
      margin-left: 15px;
      font-size: 15px;
      font-weight: bold;
      color: #303133;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .info-card {
    background: #f8f9fb;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 15px;

    .info-name {
      font-size: 14px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 8px;
      line-height: 1.4;
    }

    .info-row {
      font-size: 13px;
      color: #606266;
      margin-bottom: 4px;

      span {
        margin-right: 20px;
      }
    }
  }

  .section-box {
    margin-bottom: 20px;

    .section-title {
      font-size: 14px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 10px;
      padding-left: 8px;
      border-left: 3px solid #3064c7;
    }
  }

  .empty-text {
    color: #909399;
    font-size: 13px;
    padding: 20px 0;
    text-align: center;
  }

  .rank-top {
    color: #e6a23c;
    font-weight: bold;
  }

  .rank-good {
    color: #67c23a;
    font-weight: bold;
  }

  .rank-mid {
    color: #409eff;
  }

  .dif-up {
    color: #f56c6c;
  }

  .dif-down {
    color: #67c23a;
  }
}
</style>
